import React from 'react';
import { Modal, BackdropBackgroundModes, VerticalPositionModes } from '@nearpod-packages/core';
import classNames from 'classnames';
import styles from './DesmosTeachOnly.scss.js';
import teachOnly from '../../../../assets/ThumbnailBanner/teach_only.png.js';
import { useCustomTranslation } from '../../../../hooks/useCustomTranslation/useCustomTranslation.js';

const DesmosTeachOnly = _ref => {
  let {
    isOpen = true,
    containerRef
  } = _ref;
  const {
    tCustom
  } = useCustomTranslation();
  return /*#__PURE__*/React.createElement(Modal, {
    containerRef: containerRef,
    backdropBackground: BackdropBackgroundModes.whiteGradient,
    verticalPositionOnContainer: VerticalPositionModes.top,
    isOpen: isOpen,
    onClose: () => {},
    disableFocusTrap: true
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['modal-content']
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundImage: `url(${teachOnly})`
    },
    className: styles['modal-content__banner']
  }, /*#__PURE__*/React.createElement("p", {
    className: styles['modal-content__banner__text']
  }, tCustom('MODAL_TEACH_ONLY_TITLE'))), /*#__PURE__*/React.createElement("h2", {
    className: classNames([styles['modal-content__title']])
  }, tCustom('DESMOS_HEADER_TEXT')), /*#__PURE__*/React.createElement("p", {
    className: classNames([styles['modal-content__description']])
  }, tCustom('DESMOS_DESCRIPTION_EXISTING_ACTIVITIES')), /*#__PURE__*/React.createElement("p", {
    className: classNames([styles['modal-content__description']])
  }, tCustom('DESMOS_DESCRIPTION_CREATE'), /*#__PURE__*/React.createElement("a", {
    href: "https://nearpod.com/t/professional-development/pd/add-web-content-to-a-nearpod-lesson-L96417610",
    target: "_blank",
    rel: "noreferrer"
  }, tCustom('DESMOS_WEB_CONTENT_LINK')), ' ', tCustom('DESMOS_DESCRIPTION_FEATURE'))));
};
var DesmosTeachOnly$1 = DesmosTeachOnly;

export { DesmosTeachOnly$1 as default };
//# sourceMappingURL=DesmosTeachOnly.js.map
